<template>
  <div style="width: 98%; height: 98%; position: relative;">
    <div class="tag-title">
      <el-tag type="warning" style="width: 100%; text-align:center; ">注册会员，扫面二维码领取优惠券</el-tag>
    </div>
    <div  class="tag-title" v-if="s_show">
      <el-select v-model="selectedMoney" placeholder="请选择优惠券金额" @change="couponMoneyChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div id="qrcode" class="image"></div>
    <div class="tag-title">
      <el-alert :title="this.tipInfoAndMoney" type="info" show-icon :closable="false"></el-alert>
    </div>

    <div class="tag-title">
      <el-button type="warning" style="width: 100%;" @click="logout">退出登录</el-button>
      <div style="color:red;margin-top: 20px;font-weight: bold">
        余额： {{ balanceAmount }}元
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2' // 引入qrcode
// import { dateFormat } from '@/utils/utils'
export default {
  created () {

  },
  mounted () {
    // 进入页面，查询客户信息然后生成二维码
    this.queryMerchantInfoAndQr()
  },
  beforeDestroy () {
    // 离开页面之前销毁定时器
    this.destroyTimer()
  },
  data () {
    return {
      options: [],
      selectedMoney: '', // 下拉选择的优惠券金额
      s_show: true, // 下拉框是否显示
      value: '',
      merchantId: '', // 商户ID
      couponMoney: '', // 优惠券金额
      tipInfo: '',
      tipInfoAndMoney: '',
      qrLink: '',
      parkCode: '',
      parkName: '',
      couponUrl: '',
      myTimer: null,
      rechargeDiscount: '',
      validHours: '',
      // 商户余额
      balanceAmount: ''
    }
  },
  methods: {
    // 生成二维码按钮触发函数
    ManualGenqrcode () {
      if (this.qrcode()) {
        // 生成二维码成功，则添加刷新定时器
        this.myTimer = setInterval(this.qrcode, 60000)
      } else {
        this.destroyTimer()
      }
    },
    async checkMerchantInfo () {
      const token = window.sessionStorage.getItem('token')
      // console.log('checkMerchantInfo', token)
      if (token) {
        try {
          const { data: res } = await this.$http.get('queryMerchantInfoByToken', {
            headers: { token: token }
          })
          if (res.code === '0') {
            this.balanceAmount = res.data.balanceAmount
          }
        } catch (e) {
          // console.log('checkMerchantInfo', e)
        }
      }
    },
    // 查询客户信息然后生成二维码
    async queryMerchantInfoAndQr () {
      // 发送请求
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') {
        // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      try {
        const { data: res } = await this.$http.get('queryMerchantInfoByToken', {
          headers: { token: token }
        })
        // console.log(res)
        if (res.code === '0') {
        // console.log(JSON.stringify(res.data))
        // 获取信息
          this.merchantId = res.data.merchantId
          const couponMoney = parseFloat(res.data.couponMoney)
          this.tipInfo = res.data.tipInfo
          this.tipInfoAndMoney = this.getCouponLabel(
            res.data.tipInfo,
            couponMoney,
            res.data.rechargeDiscount,
            res.data.validHours)
          this.parkCode = res.data.parkCode
          this.parkName = res.data.parkName
          this.couponUrl = res.data.couponUrl
          this.rechargeDiscount = res.data.rechargeDiscount
          this.validHours = res.data.validHours
          this.balanceAmount = res.data.balanceAmount

          // 处理优惠券下拉
          if (res.data.couponMoneyList === '') { // 没有优惠券list
            this.s_show = false
          } else { // 列表
          // 循环加入select优惠券
          // console.log('循环加入select优惠券')
            res.data.couponMoneyList.split(',').map(value => {
              const obj = {}
              obj.value = value
              obj.label = this.getCouponLabel(
                '',
                value,
                '',
                '')
              this.options.push(obj)
              if (parseFloat(value) === couponMoney) {
                this.selectedMoney = couponMoney + ''
              }
            })
          }

          // 生成二维码
          const that = this
          this.$nextTick(() => {
            that.couponMoneyChange()
          })
          this.myTimer = setInterval(this.qrcode, 15000)
        } else {
          return this.$message.error(res.message)
        }
      } catch (e) {
        this.$message.error('获取失败')
      }
    },

    //  生成二维码通用方法
    async qrcode () {
      // 后台获取二维码内容
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') {
        // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }

      // 优惠券日期
      // const dateStr = dateFormat(new Date())
      // 选择框的优惠券金额不为空
      // if (this.selectedMoney) {
      //   this.couponMoney = this.selectedMoney
      // }
      // 检查一下商户余额
      await this.checkMerchantInfo()
      try {
        const { data: res } = await this.$http.get('createCouponlanneng', {
          headers: { token: token, 'Content-Type': 'application/json;charset=utf-8' },
          params: {
            merchantId: this.merchantId,
            couponMoney: parseFloat(this.selectedMoney),
            // beginDate: dateStr,
            // endDate: dateStr,
            couponUrl: this.couponUrl,
            parkName: this.parkName,
            parkCode: this.parkCode
          }
        })
        // console.log('优惠券地址：' + res.data)
        if (res.code === '0') {
          this.qrLink = res.data
          this.qrcodejs2()
          return true
        } else {
          this.$message.error(res.message)
          document.getElementById('qrcode').innerHTML = ''
          return false
        }
      } catch (e) {
        this.$message.error('获取失败')
      }
    },

    // 二维码生成方法
    qrcodejs2 () {
      document.getElementById('qrcode').innerHTML = '' // 首先清空二维码内容
      /* eslint-disable no-new */
      new QRCode('qrcode', {
        // 生成二维码
        width: 210,
        height: 210,
        text: this.qrLink // 二维码内容
      })
      // console.log(qrcode)
    },

    // 销毁定时器
    destroyTimer () {
      if (this.myTimer != null) {
        window.clearInterval(this.myTimer)// 出错删除定时器
      }
    },

    // 优惠券选择金额改变事件
    couponMoneyChange () {
      // this.tipInfoAndMoney = this.tipInfo + ' ' + this.selectedMoney + '元'
      this.tipInfoAndMoney = this.getCouponLabel(
        this.tipInfo,
        this.selectedMoney,
        this.rechargeDiscount.toString(),
        this.validHours.toString())
      // 手动刷新一下优惠券
      // console.log('this.tipInfoAndMoney ', this.validHours, this.selectedMoney)
      this.qrcode()
    },

    getCouponLabel (tipInfo, money, rechargeDiscount, validHours) {
      let tipInfoAndMoney = ''
      if (money === -1 || money === '-1') {
        tipInfoAndMoney = '单次免费'
      } else if (money === -2 || money === '-2') {
        tipInfoAndMoney = '时段免费'

        if (validHours && validHours.length > 0) {
          tipInfoAndMoney += `${validHours}小时`
        }
      } else if (money === '-3' || money === -3) {
        tipInfoAndMoney = '折扣减免'
        if (rechargeDiscount && rechargeDiscount.length > 0) {
          tipInfoAndMoney += `${(parseFloat(rechargeDiscount) * 10).toFixed(1)}折`
        }
      } else {
        if (tipInfo && tipInfo.length > 0) {
          tipInfoAndMoney = tipInfo
        }
        tipInfoAndMoney = `${tipInfoAndMoney} ${money}元`
      }
      return tipInfoAndMoney
    },

    // 登出
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.tag-title {
  position: relative;
  width: 210px;
  margin: 10px auto 0;
  margin-bottom: 20px 0 10px 0;
}
.image {
  position: relative;
  width: 210px;
  height: 210px;
  display: block;
  margin: 10px auto 0;
  padding: 5px;
}
</style>
